var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gear-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.164,
    height: 17.164,
    viewBox: "0 0 17.164 17.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M10.089,1.126a1.572,1.572,0,0,0-3.014,0l-.107.365a1.57,1.57,0,0,1-2.258.935l-.333-.182A1.571,1.571,0,0,0,2.245,4.376l.181.334a1.571,1.571,0,0,1-.935,2.258l-.365.107a1.572,1.572,0,0,0,0,3.014l.365.107a1.57,1.57,0,0,1,.935,2.258l-.182.333a1.571,1.571,0,0,0,2.131,2.131l.334-.181a1.57,1.57,0,0,1,2.258.935l.107.365a1.572,1.572,0,0,0,3.014,0l.107-.365a1.57,1.57,0,0,1,2.258-.935l.333.182a1.571,1.571,0,0,0,2.131-2.131l-.181-.334a1.57,1.57,0,0,1,.935-2.258l.365-.107a1.572,1.572,0,0,0,0-3.014l-.365-.107a1.57,1.57,0,0,1-.935-2.258l.182-.333a1.571,1.571,0,0,0-2.131-2.131l-.334.181A1.57,1.57,0,0,1,10.2,1.491l-.107-.365Zm-1.507,10.6a3.143,3.143,0,1,1,3.142-3.144,3.143,3.143,0,0,1-3.142,3.144Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.732e018fa1e6780ed79cc49975671407.svg";
export { ForwardRef as ReactComponent };